module.exports = __webpack_public_path__ + "static/media/bg_finger_update.bdb07c97.svg";